var _path, _defs, _clipPath, _path2, _defs2, _clipPath2, _path3, _defs3, _clipPath3, _path4, _defs4, _clipPath4, _g, _defs5, _clipPath5, _path5, _defs6, _clipPath6, _path6, _defs7, _clipPath7, _path7, _defs8, _clipPath8, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3498DB",
    d: "M50 0c27.613 0 50 22.386 50 50 0 27.615-22.387 50-50 50-27.614 0-50-22.385-50-50C0 22.386 22.386 0 50 0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 50,
    cy: 50,
    r: 50
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#2980B9",
    d: "M0 100h31L20 49 0 69z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 50,
    cy: 50,
    r: 50
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "#EBEDEE",
    d: "M74.736 100L80 50H20l5.263 50z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "e",
    cx: 50,
    cy: 50,
    r: 50
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "#C3C9CD",
    d: "M50 100V50H20l5.172 50z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "g",
    cx: 50,
    cy: 50,
    r: 50
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#95A5A6",
    d: "M79.982 50.801l-.26.004C77.756 53.738 65.203 56 50 56c-15.15 0-27.67-2.246-29.704-5.164h-.285C19.956 50.834 20 53.945 20 54c0 3.314 13.432 6 30 6 16.568 0 30-2.686 30-6 0-.066.038-3.238-.018-3.199z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M50.078 60h-.357C33.281 59.971 20 57.295 20 54c0-.055-.044-3.166.011-3.164.01 0 15.013 0 30.009-.005.024.009.08 9.185.058 9.169z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEDEE",
    d: "M50 44c16.568 0 30 2.687 30 6 0 3.314-13.432 6-30 6-16.568 0-30-2.686-30-6 0-3.313 13.432-6 30-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C40E",
    d: "M50 56c7.678 0 14.678-.577 19.98-1.525l-9.48-9.479-11.005 11.002L50 56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M50 56c4.227 0 8.247-.175 11.895-.49L46 39.615 30.978 54.639C36.154 55.488 42.776 56 50 56z"
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "i",
    cx: 50,
    cy: 50,
    r: 50
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    overflow: "visible"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "#95A5A6",
    d: "M33.628 100L32 65a2 2 0 0 0-4 0l1.628 35h4z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "k",
    cx: 50,
    cy: 50,
    r: 50
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    overflow: "visible"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "#BDC3C7",
    d: "M69.372 100L71 65a2 2 0 0 0-4 0l-1.628 35h4z"
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "m",
    cx: 50,
    cy: 50,
    r: 50
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    overflow: "visible"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#n)",
    fill: "#BDC3C7",
    d: "M59.21 100L60 66a2 2 0 0 0-4 0l-.79 34h4z"
  })), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "o",
    cx: 50,
    cy: 50,
    r: 50
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    overflow: "visible"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#p)",
    fill: "#95A5A6",
    d: "M43.791 100L43 66a2 2 0 0 0-4 0l.791 34h4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c65df273bf552d578d3fc07b56e2c518.svg";
export { ForwardRef as ReactComponent };